import e from "react";
const o = e.createContext({
  closeModal: null
}), r = o.Provider, a = o.Consumer;
export {
  a as ModalConsumer,
  o as ModalContext,
  r as ModalProvider,
  o as default
};
